export default "https://cdn-static.gokick.com/assets/fd6b0a6afc37e3a7e4b7ae7c7f4dd4a202138084/images/tangerine-flavor.1fe86552bc4a40407da21340599dcac8.png";